export const ru = {
    'add-creatives': 'Добавить выбранные',
    campaigns: 'Кампании',
    'campaigns-dropdown-label': 'Кампании, в которых используется',
    'campaigns-not-found': 'Кампаний не найдено',
    'cancel-and-return': 'Отмена',
    create: 'Создать на основе',
    'create-new': 'создать',
    'get-link-dropdown-label': 'Получить ссылку',
    'items-not-found': 'Здесь пока пусто, самое время что-нибудь {presetsLink}',
    preview: 'Посмотреть',
    'rename-label': 'Переименовать',
    'search-placeholder': 'Найти',
    'show-linked-only': 'Показывать только креативы, привязанные к объявлениям',
    'sound-setting': 'Проигрывать звук'
};
